import React, { useState } from 'react'
import DashboardIcon from '../elements/icons/DashboardIcon'
import UsersIcon from '../elements/icons/UsersIcon'
import { NavLink, useLocation } from 'react-router-dom'
import BriefcaseIcon from '../elements/icons/BriefcaseIcon'
import BookIcon from '../elements/icons/BookIcon'
import AcademicCapIcon from '../elements/icons/AcademicCapIcon'
import BuildingOfficeIcon from '../elements/icons/BuildingOfficeIcon'
// import CogIcon from '../elements/icons/CogIcon'
import BoxIcon from '../elements/icons/BoxIcon'
import UserGroupIcon from '../elements/icons/UserGroupIcon'
import CogIcon from '../elements/icons/CogIcon'
const CollapsedSidebar = () => {
    const location = useLocation();
    const currentRoute = location.pathname;
    const [activeToolTip, setActiveToolTip] = useState('')

    return (
        <div className="relative w-full min-h-screen bg-gray-50 px-4 flex flex-col items-start pt-12">
            {/* <div className="pt-3 w-full flex items-center justify-center mb-12">
                <img src={VcmLogo} alt="" className="w-3/5" />
            </div> */}
            <NavLink to="/admin/dashboard" className={`${currentRoute.includes('admin/dashboard') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative" 
                    onMouseEnter={()=>{setActiveToolTip('dashboard')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <DashboardIcon className={`h6 w-6`} />
                    {activeToolTip === 'dashboard' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Dashboard</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/administration" className={`${currentRoute.includes('admin/administration') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('administration')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <BuildingOfficeIcon className={`h6 w-6`} />
                    {activeToolTip === 'administration' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Administration</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/accounting" className={`${currentRoute.includes('admin/accounting') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('accounting')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <BriefcaseIcon className={`h6 w-6`} />
                    {activeToolTip === 'accounting' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Finance & Accounting</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/academics" className={`${currentRoute.includes('admin/academics') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('academics')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <BookIcon className={`h6 w-6`} />
                    {activeToolTip === 'academics' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Academics</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/parents" className={`${currentRoute.includes('admin/parents') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('parents')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <UsersIcon className={`w-6 h-6`} />
                    {activeToolTip === 'parents' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Parents</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/students" className={`${currentRoute.includes('admin/students') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('students')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <AcademicCapIcon className={`w-6 h-6`} />
                    {activeToolTip === 'students' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Students</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/college-staff" className={`${currentRoute.includes('admin/college-staff') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('staff')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <UserGroupIcon className={`w-6 h-6`} />
                    {activeToolTip === 'staff' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>College Staff</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink to="/admin/inventory"  className={`${currentRoute.includes('admin/inventory') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('inventory')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <BoxIcon className={`w-6 h-6`} />
                    {activeToolTip === 'inventory' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Stock/Inventory</p>
                    </div>}
                </div>
            </NavLink>

            <NavLink 
                to="/admin/settings"  
                className={`${currentRoute.includes('admin/settings') ? 'text-purple-700' : 'text-black'} text-sm flex  p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1 relative"
                    onMouseEnter={()=>{setActiveToolTip('settings')}} 
                    onMouseLeave={()=>{setActiveToolTip('')}}
                >
                    <CogIcon className={`w-6 h-6`} />
                    {activeToolTip === 'settings' && <div className='absolute -top-[14px] -right-[220px] bg-gray-700 p-4 z-50 w-[200px]'>
                        <p className='text-white'>Settings</p>
                    </div>}
                </div>
            </NavLink>
        </div>
        
    )
}

export default CollapsedSidebar
